import { useRef, useState } from 'react'
import { webchatClasses } from '../../../../styles/classes'
import { Mic } from 'lucide-react'

type SpeechRecognitionProps = {
  disabled: boolean
  setTextInput: (value: string) => void
}

export const SpeechRecognition = ({ disabled, setTextInput }: SpeechRecognitionProps) => {
  const [isListening, setIsListening] = useState(false)
  const recognitionRef = useRef<any | null>(null)
  const { voiceButton } = webchatClasses.composer

  const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition

  const handleSpeechRecognition = (): void => {
    if (!recognitionRef.current) {
      recognitionRef.current = new SpeechRecognition()
    }

    const recognition = recognitionRef.current

    if (!recognition) return

    recognition.continuous = true

    recognition.onresult = (event: any) => {
      const transcript = event.results?.[0]?.[0]?.transcript ?? ''
      setTextInput(transcript ?? '')
      recognition.stop()
      setIsListening(false)
    }

    if (isListening) {
      recognition.stop()
      setIsListening(false)
    } else {
      recognition.start()
      setIsListening(true)
    }
  }

  if (!SpeechRecognition) return

  return (
    <Mic
      {...voiceButton}
      tabIndex={0}
      aria-label="Voice Input Button"
      role="button"
      data-show={!disabled}
      data-listens={!!isListening}
      onClick={handleSpeechRecognition}
    />
  )
}
